import { createSelector } from 'reselect';

export const getVisibilityFilter = state => state.filters.visibilityFilter;
export const getSortKey = state => state.filters.sortKey;
export const getSortOrders = state => state.filters.sortOrders;

export const getDifficultyFilter = state => state.filters.difficultyFilter;
export const getTonalityFilter = state => state.filters.tonalityFilter;
export const getStatusFilter = state => state.filters.statusFilter;
export const getTypeFilter = state => state.filters.typeFilter;
export const getAuthorFilter = state => state.filters.authorFilter;
export const getPerformerFilter = state => state.filters.performerFilter;

export const getFilter = (visibilityFilter, difficultyFilter, tonalityFilter, statusFilter, typeFilter,
                          authorFilter, performerFilter,
                          sortKey, sortOrders, offers) => {
  let order = sortOrders[sortKey] || 1;
  if (visibilityFilter) offers = offers.filter(offer => offer.title.toLowerCase().includes(visibilityFilter));
  if (difficultyFilter > 0){
    offers = offers.filter(offer => offer.difficulty === difficultyFilter);
  }
  if (tonalityFilter > 0){
    offers = offers.filter(offer => offer.tonality === tonalityFilter);
  }
  if (statusFilter > 0){
    offers = offers.filter(offer => offer.status === statusFilter);
  }
  if (typeFilter.length > 0){
    offers = offers.filter(offer => offer.offer_type === typeFilter);
  }
  if (authorFilter > 0){
    offers = offers.filter(offer => offer.author_id === authorFilter);
  }
  if (performerFilter !== null){
    offers = offers.filter(offer => offer.performer_id === parseInt(performerFilter));
  }
  if (sortKey) offers = offers.slice().sort(
    (a, b) => {
      a = a[sortKey];
      b = b[sortKey];
      return (a === b ? 0 : a > b ? 1 : -1) * order
    });
  return offers;
};


export const getUserFilter = (visibilityFilter, users) => {
  if (visibilityFilter) users = users.filter(user => user.full_name.toLowerCase().includes(visibilityFilter));
  return users;
};

export const getVisibleOffers = (getOffers) => createSelector(
  [getVisibilityFilter, getDifficultyFilter, getTonalityFilter, getStatusFilter,
    getTypeFilter, getAuthorFilter, getPerformerFilter, getSortKey, getSortOrders, getOffers],
  (visibilityFilter, difficultyFilter, tonalityFilter, statusFilter,
   typeFilter, authorFilter, performerFilter, sortKey, sortOrders, offers) => {
    return getFilter(visibilityFilter, difficultyFilter, tonalityFilter, statusFilter, typeFilter,
      authorFilter, performerFilter,
      sortKey, sortOrders, offers);
  }
);

export const getVisibleAuthors = (getAuthors) => createSelector(
  [getVisibilityFilter, getAuthors],
  (visibilityFilter, authors) => {
    return getUserFilter(visibilityFilter, authors);
  }
);